import ApiClient from "../api/apiClient";

const LOGIN = "/auth/login";
const FORGOT_PASSWORD = "/auth/forgot-password";
const RESET_PASSWORD = "/auth/reset-password/";
const DEACTIVATE_FORGOT_PASSWORD = "/auth/deactivate-forgot-password/";
const LOGOUT = "/auth/logout"

const login = (data) => {
  const url = LOGIN;
  return ApiClient.post(url, data);
};

const forgotPassword = (data) => {
  const url = FORGOT_PASSWORD;
  return ApiClient.post(url, { ...data, panel: 1 });
};

const resetPassword = ({ token, data }) => {
  const url = RESET_PASSWORD + token;
  return ApiClient.post(url, data);
};

const deactivateForgotPassword = (token) => {
  const url = DEACTIVATE_FORGOT_PASSWORD + token;
  return ApiClient.get(url);
};

const logout = () => {
  return ApiClient.post(LOGOUT);
};

export const authServie = {
  login,
  forgotPassword,
  resetPassword,
  deactivateForgotPassword,
  logout,
};
